class ContactSection extends HTMLElement {
  constructor() {
    super();
    const validation = [
      {
        selector: "[data-name-input]",
        translationKey: "name",
      },
      {
        selector: "[data-email-input]",
        translationKey: "email",
      },
      {
        selector: "[data-reason-input]",
        translationKey: "reason",
      },
      {
        selector: "[data-message-input]",
        translationKey: "message",
      },
    ];

    validation.forEach((item) => {
      const input = this.querySelector(item.selector);
      if (!input) return;

      input.addEventListener("invalid", function (e) {
        if (input.validity.valueMissing) {
          input.setCustomValidity(theme.translations(window.localeStrings.contactFormValidation, item.translationKey));
        }
      });

      input.addEventListener("input", function (e) {
        input.setCustomValidity("");
      });
    });
  }
}

if (!customElements.get("contact-section")) {
  customElements.define("contact-section", ContactSection);
}
